export function salesDocType(salesDocument: any): string {
  if(!salesDocument) return '';
  let salesDocType = '';
  switch (salesDocument.type) {
    case 'invoice':
      salesDocType = 'INV';
      break;

    case 'Debit Note':
      salesDocType = 'DN';
      break;
  
    case 'Credit Note':
      switch (salesDocument.subtype) {
        case 'Customer Discount':
          salesDocType = 'CN-D';
          break;

        case 'Returned Item':
          salesDocType = 'CN-MR';
          break;

        case 'Cancelled Invoice':
          salesDocType = 'CN-NVR';
          break;
        
        default:
          salesDocType = 'CN';
          break;
      }
      break;

    case 'Received Partial':
      salesDocType = 'RVP';
      break;

    case 'Received Full':
      salesDocType = 'RVF';
      break;

    case 'Received Advance':
      salesDocType = 'RVA';
      break;
    
    case 'Return Check':
      salesDocType = 'RTC';
      break;
    
    case 'Received Deferred':
      salesDocType = 'RVD';
      break;

    case 'misc':
      salesDocType = 'MISC-INV';
      break;

    default:
      salesDocType = 'N/A';
      break;
  }
  return salesDocType;
}